import { render, staticRenderFns } from "./CVideoPagination.vue?vue&type=template&id=7fe00a39&"
import script from "./CVideoPagination.vue?vue&type=script&lang=js&"
export * from "./CVideoPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports